import React, { useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [hoverLink, setHoverLink] = useState(null);
  const [hoverSocial, setHoverSocial] = useState(null);

  const quickLinks = [
    { name: "Product Catalog", path: "/" },
    { name: "Quote Builder", path: "/" },
    { name: "Service & Support", path: "/" },
    { name: "Spare Parts", path: "/" },
    { name: "Training", path: "/" },
  ];

  const products = [
    "Forklifts",
    "Drum Lifters",
    "Conveyors",
    "Stackers",
    "Pallet Trucks",
  ];

  const headerStyle = { fontWeight: "700", color: "white", marginBottom: "20px", fontSize: "18px" };
  const textStyle = { color: "#d1d5db", fontSize: "14px", transition: "0.2s", textDecoration: "none" };

  return (
    <footer
      style={{
        backgroundColor: "#0f1c3f",
        color: "white",
        paddingTop: "60px",
      }}
    >
      <div className="container">
        {/* Responsive Grid with Row Gap */}
        <div className="row g-4">
          
          {/* Brand Column - Full width on mobile, 4 cols on desktop */}
          <div className="col-12 col-lg-4 pe-lg-5 mb-4">
            <div className="d-flex align-items-center gap-3 mb-4">
              <div
                style={{
                  backgroundColor: "#f97316",
                  width: "55px",
                  height: "55px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "900",
                  fontSize: "28px",
                  borderRadius: "8px",
                  color: "white"
                }}
              >
                A
              </div>
              <div>
                <div style={{ fontWeight: "700", fontSize: "20px", letterSpacing: "0.5px" }}>
                  AETERNITAS SOLUTIONS
                </div>
                <div style={{ fontSize: "13px", color: "#d1d5db", marginTop: "-2px" }}>
                  Pvt Ltd
                </div>
              </div>
            </div>
            <p style={{ fontSize: "15px", color: "#d1d5db", lineHeight: "1.6", maxWidth: "320px" }}>
              Premium Industrial Material Handling Equipment solutions for
              warehouses, manufacturing facilities, and logistics operations across India.
            </p>
          </div>

          {/* Products Column - 2 per row on mobile, 2 cols on desktop */}
          <div className="col-6 col-md-4 col-lg-2 mb-4">
            <h6 style={headerStyle}>Products</h6>
            <div className="d-flex flex-column gap-2">
              {products.map((item, index) => (
                <div
                  key={index}
                  onMouseEnter={() => setHoverLink(`prod-${index}`)}
                  onMouseLeave={() => setHoverLink(null)}
                  style={{
                    ...textStyle,
                    cursor: "pointer",
                    color: hoverLink === `prod-${index}` ? "white" : "#d1d5db",
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links Column - 2 per row on mobile, 3 cols on desktop */}
          <div className="col-6 col-md-4 col-lg-3 mb-4 ps-lg-5">
            <h6 style={headerStyle}>Quick Links</h6>
            <div className="d-flex flex-column gap-2">
              {quickLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  onMouseEnter={() => setHoverLink(index)}
                  onMouseLeave={() => setHoverLink(null)}
                  style={{
                    ...textStyle,
                    color: hoverLink === index ? "white" : "#d1d5db",
                  }}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Column - Full width on mobile/tablet, 3 cols on desktop */}
          <div className="col-12 col-md-4 col-lg-3 mb-4">
            <h6 style={headerStyle}>Contact Us</h6>
            <div className="d-flex flex-column gap-3 mb-4" style={{ fontSize: "15px", color: "#d1d5db" }}>
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>📍</span> Vadodara, Gujarat, India
              </div>
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>📞</span> +91 265 123 4567
              </div>
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>✉</span> info@aeternitassolutions.com
              </div>
            </div>

            <div className="d-flex gap-2">
              {[
                { 
                  icon: (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                  ) 
                },
                { 
                  icon: (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                    </svg>
                  ) 
                }
              ].map((social, index) => (
                <div
                  key={index}
                  onMouseEnter={() => setHoverSocial(index)}
                  onMouseLeave={() => setHoverSocial(null)}
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: hoverSocial === index ? "#2d3748" : "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition: "0.2s",
                    color: "white"
                  }}
                >
                  {social.icon}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      <div
        className="mt-5 py-4"
        style={{
          borderTop: "1px solid rgba(255,255,255,0.1)",
          fontSize: "14px",
          color: "#9ca3af",
        }}
      >
        <div className="container text-start">
          Aeternitas Solutions Pvt Ltd | CIN: U46901GJ2024PTC148927 | Vadodara, Gujarat 2026
        </div>
      </div>
    </footer>
  );
};

export default Footer;